import { createContext, useContext, useEffect, useState } from "react";

import { aiConversation, authentication, getAllUsers, getMyData, registerAccount, signoutAccount, updateAccount, uploadPic, validateLesson } from "./authentication.services";
import { getItem, saveItem } from "../../_helpers/localstorage";

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState();
    const [token, setToken] = useState();
    const [user, setUser] = useState();
    const [accounts, setAccounts] = useState([]);

    /** save auth token */
    const saveAccessToken = async (token) => {
        try {
           await saveItem("token",token);      
        } catch (e) {
            alert(e);
        }
    }
    
    /** retrieve token */
    const getAuthToken = async () => {
        try {
            const response = await getItem("token");
            return response;
        } catch (e) {
            return (e)
        }
    }

    const isAdmin = user?.role === "admin" || user?.role === "superadmin";
    const isSuperAdmin = user?.role === "superadmin";

    /**Login user */
    const userRegistration = async (creds) => {
        try {
            setIsLoading(true)
            const response = await registerAccount(creds);
            const res = await response.json();
            if (!res?.error && res?.account) {
                setIsAuthenticated(true);
                setUser(res?.account);
                saveAccessToken(res?.token);
                setIsLoading(false);
                window.location.href='/avatar';
            }
            setIsLoading(false);
            return res;
        } catch (e) {
            return ({error: e});
        }
    }

    /** Authenticate user */
    const userSignin = async (creds) =>{
        try {
            setIsLoading(true);
            const  response = await authentication(creds);
            const res = await response.json();

            if (res?.error){
                setIsLoading(false);
                setIsAuthenticated(false);
                return res;
            }

            setIsLoading(false);
            setIsAuthenticated(true);
            setUser(res?.account);
            setToken(res?.token);
            saveAccessToken(res?.token);
          
            window.location.href="/"
            return;
        } catch (e) {
            setIsLoading(false);
            return ({error: e});
        }
    }

    /** Logout user */
    const logoutUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await signoutAccount(token);
            const status = response.status;
            if (status === 200) {
                setIsLoading(false);
                setIsAuthenticated(false)
                window.location.reload();
                return;
            }else{
                setIsLoading(false);
                return {
                    error: 'Unable to sign out!'
                }
            }
        } catch (error) {
            return ({error})
        }
    }

    /** updload user avatar */
    const saveUserAvatar = async (imageFile, token) => {
        try {
            setIsLoading(true)
            const fileResp = await uploadPic(imageFile);
            const fileRes = await fileResp.json();
            console.log(fileRes);
            const { url } = fileRes;
            const data = {avatar: url};
            const response = await updateAccount(data,token);
            const res = await response.json();
            if (res?.error){
                console.log(res);
                setIsLoading(false);
                return res;
            }
            setIsLoading(false);
            return res;
        } catch (error) {
            setIsLoading(false);
            return ({error});
        }
    }

    /** Authorize user */
    const authorizeUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await getMyData(token);
            const res = await response.json();
            setIsLoading(false);
            return res;
        } catch (e) {
            setIsLoading(false);
            return ({error: e})
        }
    }

    const markAsComplete = async (data, token) => {
        try {
            setIsLoading(true);
            const response = await validateLesson(data, token);
            const res = await response.json();
            setIsLoading(false);
            return res;
        } catch (error) {
            setIsLoading(false);
            return ({error})
        }
    }

    /** ask ai */
    const chatWithAI = async (data, token) => {
        try {
            setIsLoading(true);
            const response = await aiConversation(data, token);
            const res = await response.json();
            setIsLoading(false);
            return res; 
        } catch (error) {
            setIsLoading(false);
            return ({error})
        }
    }
 
    useEffect(() => {
        const getAllUserData = async() => {
            try {
                const response = await getAllUsers();
                const users = await response.json();
                return users;
            } catch (error) {
                console.log(error);
            }
        }
        (async() => {
            const tk = await getAuthToken();
            if (tk?.error){
                console.log({error: tk?.error});
                setIsAuthenticated(false);
                return;
            }
            setToken(tk);

            /** all accounts */
            const allUsers = await getAllUserData();
            setAccounts(allUsers);

            const account  = await authorizeUser(tk);
            if (account?.error || !account){
                setIsAuthenticated(false);
                return;
            }
            setUser(account);
            setIsAuthenticated(true);
        })();
        //console.log({isAuthenticated});
        return () => {
            console.log("")
        }
    },[isAuthenticated]);

    return (
        <AuthenticationContext.Provider
            value={{
                user,
                isAuthenticated,
                isLoading,
                token,
                isAdmin,
                isSuperAdmin,
                accounts,
                userSignin,
                userRegistration,
                saveUserAvatar,
                logoutUser,
                markAsComplete,
                chatWithAI
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    )
}

export const useAuth = () => useContext(AuthenticationContext);